<template>
  <!-- 远程专家 -->
  <div class="visual-box2" style="margin-top: 0px; position: relative">
    <div class="loadingScreenMod indexJust" v-if="remoteExperts">
      <loadingModule />
    </div>
    <div class="loadingScreenMod indexJust" v-if="!remoteExperts && expertlist.length <= 0">
      <noData />
    </div>
    <div class="expert" v-if="!remoteExperts && expertlist.length > 0">
      <div class="expertimg" v-for="(item, index) in expertlist" :key="index">
        <div class="expertdiimg" v-if="item">
          <img v-if="item.img" :src="item.img" alt />
          <img v-else src="https://file.vmuyun.com/image/cover/3F709739F2664A1797773BBA74D42971-6-2.png?width=100&height=100" alt />
          <div class="expertdaname">
            <p style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; box-sizing: border-box; padding-right: 10px">
              {{ item.expertName }}
            </p>
          </div>
        </div>
        <div class="expertdiInfo" v-if="item">
          <section>
            <el-tooltip :content="item.livestockTypeName" placement="bottom-start" effect="light">
              <p style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; cursor: pointer">
                擅长:{{ item.livestockTypeName }}
              </p>
            </el-tooltip>
            <p>从业:{{ item.workYears }}年</p>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { queryExpertUserInfo } from '@/api/zzry'; // 固定数据
import { queryRecommendExpertUserInfo } from '@/api/zzry'; // 推荐数据
import loadingModule from '@/views/businessModule/loading1.vue';
import noData from '@/views/businessModule/noData.vue';
export default {
  name: 'projectTop',
  created() {
    this.initData();
  },
  mounted() {},
  props: {
    speed: {
      default: 1,
      type: Number
    }
  },
  computed: {},
  components: {
    loadingModule,
    noData
  },
  data() {
    return {
      expertlist: [],
      remoteExperts: false
    };
  },
  methods: {
    initData() {
      this.remoteExperts = true;
      let info = JSON.parse(localStorage.getItem('info'));
      let userInfo_ZHXM = JSON.parse(localStorage.getItem('userInfo_ZHXM'));
      let applicationType = localStorage.getItem('applicationType');
      let _params = {
        areaId: info.authProvincesCityAreas
      };
      if (userInfo_ZHXM && applicationType == 2) {
        _params.applicationId = userInfo_ZHXM.applicationId;
        _params.deptId = userInfo_ZHXM.deptId;
      }
      queryRecommendExpertUserInfo(_params)
        .then(res => {
          this.remoteExperts = false;
          // res.data.data = [];
          this.expertlist = res.data.data;
          // for (var i = 0; this.expertlist.length < 3; i++) {
          //   this.expertlist.push('');
          // }
        })
        .catch(() => {
          this.remoteExperts = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  margin-block-start: 0em;
  margin-block-end: 0em;
  line-height: 20px;
}
.visual-box2,
.expert,
.loadingScreenMod {
  height: 100%;
}
.expert {
  display: flex;
  // justify-content: space-around;
  box-sizing: border-box;
  padding: 10px;
}
.expertimg {
  height: 100%;
  background-image: url('../../../static/large/renwudi.png');
  background-size: 100% 100%;
  font-size: 13px;
  // flex: 1;
  width: 33.3%;
  box-sizing: border-box;
  &:nth-child(2) {
    margin: 0 10px;
  }
}
.expertdiimg {
  width: 80%;
  height: 65%;
  background-image: url('../../../static/large/touxiang.png');
  background-size: 100% 100%;
  position: relative;
  margin: 10px auto;
  margin-bottom: 0;
  overflow: hidden;
}
.expertdiimg img {
  width: 100%;
  height: calc(100% - 5px);
  object-fit: cover;
}
.expertdiInfo {
  width: 80%;
  margin: 0 auto;
  font-size: 12px;
  color: white;
  height: 25%;
  display: flex;
  display: -ms-flexbox;
  -webkit-display: flex;
  -webkit-align-items: center;
  align-items: center;
  // -webkit-justify-content: center;
  // justify-content: center;
  // -webkit-justify-content: center;
  align-items: center;
  div {
    width: 90%;
  }
  p {
    line-height: 16px;
  }
}
.expertdaname {
  position: absolute;
  bottom: 5px;
  left: 0;
  background-image: url('../../../static/large/namedi.png');
  background-size: 100% 100%;
  color: #1d5fd1;
  font-size: 12px;
  font-weight: 600;
  width: auto;
  max-width: 100%;
  min-width: 40px;
  p {
    padding-left: 5px;
    padding-right: 20px;
    margin: 0;
    padding-top: 1px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.indexJust {
  display: flex;
  display: -ms-flexbox;
  -webkit-display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/businessModule/projectExpert-yulin.vue